import img11 from "../../images/chapters/09/11.jpg";
import img12 from "../../images/chapters/09/12.jpg";
import img13 from "../../images/chapters/09/13.jpg";
import img14 from "../../images/chapters/09/14.jpg";
import img15 from "../../images/chapters/09/15.jpg";
import img16 from "../../images/chapters/09/16.jpg";
import img17 from "../../images/chapters/09/17.jpg";
import img18 from "../../images/chapters/09/18.jpg";
import img19 from "../../images/chapters/09/19.jpg";
import img20 from "../../images/chapters/09/20.jpg";
import img21 from "../../images/chapters/09/21.jpg";

import img22 from "../../images/chapters/09/22.jpg";
import img23 from "../../images/chapters/09/23.jpg";
import img24 from "../../images/chapters/09/24.jpg";
import img25 from "../../images/chapters/09/25.jpg";
import img26 from "../../images/chapters/09/26.jpg";
import img27 from "../../images/chapters/09/27.jpg";

export const captions = [
  "Passive Seismic Experiments Package",
  "Laser Ranging RetroReflector",
  "Lunar surface and horizon",
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam sed sapien vel mauris accumsan tempus sed et elit. Donec arcu odio, eleifend ut erat id, pharetra laoreet sem. Pellentesque eu odio eu nisi scelerisque efficitur quis at urna. Quisque auctor at est nec accumsan. Duis laoreet luctus lorem ac vestibulum. Praesent leo massa, laoreet tincidunt purus sed, aliquam auctor purus. Duis sollicitudin tempor dui quis sagittis. Curabitur venenatis arcu id venenatis pretium. Donec luctus sit amet diam at tristique. Vestibulum a dolor dapibus, congue nunc sit amet, luctus mauris. Vestibulum interdum viverra venenatis.",
  "Buzz Aldrin sets the Passive Seismic Experiments Package (PSEP) (left) and the Laser Ranging RetroReflector (LRRR) (right) down at the deployment area.",
  "Buzz Aldrin deploys the Passive Seismic Experiments Package (PSEP). The Laser Ranging RetroReflector (LRRR)\nis visible behind him to the left.",
  "The deployed Laser Ranging RetroReflector (LRRR).",
  "The deployed Passive Seismic Experiments Package.",
  "View of the Lunar Module at Tranquility Base.\nImage taken by Astronaut Neil A. Armstrong.",
  "Extreme close-up of the\nLunar Module",
];

export const list = [
  { img: img11, caption: captions[6] },
  { img: img12, caption: captions[7] },
  { img: img13 },
  { img: img14 },
  { img: img15 },
  { img: img16 },
  { img: img17 },
  { img: img18 },
  { img: img19 },
  { img: img20 },
  { img: img21, caption: captions[8] },
];

export const list2 = [
  { img: img22, caption: captions[9] },
  { img: img23 },
  { img: img24 },
  { img: img25 },
  { img: img26 },
  { img: img27 },
];
